export default "__VITE_ASSET__101e5f5c__"